export default "__VITE_ASSET__BYgCH90K__"